import * as React from 'react'
import { Link } from 'react-router-dom'
import { Calendar } from 'react-widgets'
import { classes } from '@framework/Globals'
import * as AppContext from '@framework/AppContext'
import { ModelState } from '@framework/Signum.Entities'
import { ValidationError } from '@framework/Services'
import * as AuthClient from '@extensions/Authorization/AuthClient'
import { LoginAuthMessage } from "@extensions/Authorization/Signum.Entities.Authorization";
import { CustomerNameComponent } from "./Layout";
import { licenseInfo } from '@saturn/License/LicenseClient';

export default function FarazLogin() {
  const [modelState, setModelState] = React.useState<ModelState | undefined>(undefined);
  const userName = React.useRef<HTMLInputElement>(null);
  const password = React.useRef<HTMLInputElement>(null);
  const rememberMe = React.useRef<HTMLInputElement>(null);
  const login = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
    userName.current!.focus(); undefined
  }, []);


  function handleSubmit(e: React.FormEvent<any>) {

    e.preventDefault();

    if (login.current)
      login.current.disabled = true;

    const request: AuthClient.API.LoginRequest = {
      userName: userName.current!.value,
      password: password.current!.value,
      rememberMe: rememberMe.current ? rememberMe.current.checked : undefined,
    };

    AuthClient.API.login(request)
      .then(response => {
        AuthClient.setAuthToken(response.token, response.authenticationType);
        AuthClient.setCurrentUser(response.userEntity);
        AuthClient.Options.onLogin();
      })
      .catch((e: ValidationError) => {
        if (e.modelState) {
          if (login.current)
            login.current.disabled = false;

          setModelState(e.modelState);
        }
      })
      .done();
  }

  function error(field: string) {
    return modelState && modelState[field];
  }

  return (
    <form onSubmit={(e) => handleSubmit(e)} className="w-100">
      <div>
        <div className="login-box" >
          <div className="form-group">
            <img className="img-responsive" src={AppContext.toAbsoluteUrl("~/api/bigLogo")} />
            <h2><CustomerNameComponent customerName={licenseInfo.customerName} /></h2>
          </div>

          {licenseInfo.expired ?
            <div className="alert alert-warning">
              Your licesne has expired. (See License.json)
            </div> :
            <div>
              <div className={classes("form-group", error("userName") ? "has-error" : undefined)}>
                <div className="input-group">
                  <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                  <input type="text" className="form-control" id="userName" ref={userName} placeholder={LoginAuthMessage.Username.niceToString()} />
                </div>
                {error("userName") && <span className="help-block">{error("userName")}</span>}
              </div>

              <div className={classes("form-group", error("password") ? "has-error" : undefined)}>
                <div className="input-group">
                  <span className="input-group-addon"><i className="glyphicon glyphicon-lock"></i></span>
                  <input type="password" className="form-control" id="password" ref={password} placeholder={LoginAuthMessage.Password.niceToString()} />
                </div>
                {error("password") && <span className="help-block">{error("password")}</span>}
              </div>

              {AuthClient.Options.userTicket &&
                <div className="form-group">
                  <div className="checkbox">
                    <label><input type="checkbox" ref={rememberMe} />&nbsp;{LoginAuthMessage.RememberMe.niceToString()}</label>
                  </div>
                </div>}

              <div className="form-group">
                <button ref={login} className="btn btn-primary" id="login" type="submit">{LoginAuthMessage.Login.niceToString()}</button>
                {error("login") && <span className="help-block" style={{ color: "red" }}>{error("login")}</span>}
              </div>

              {FarazLogin.customLoginButtons && FarazLogin.customLoginButtons()}

              {AuthClient.Options.resetPassword &&
                <div className="form-group">
                  <Link to="~/auth/forgotPasswordEmail">{LoginAuthMessage.IHaveForgottenMyPassword.niceToString()}</Link>
                </div>
              }
            </div>}
        </div>
      </div>
    </form>
  );
}

FarazLogin.customLoginButtons = null as (null | (() => React.ReactElement<any>));
